import React from 'react'
import Header from '../Components/Header'
import HeroBanner from '../Components/HeroBanner'
import Phrase from '../Components/Phrase'
import AboutUs from '../Components/AboutUs'
import Valores from '../Components/Valores'
import Caracteristicas from '../Components/Caracteristicas'
import SecondaryBanner from '../Components/SecondaryBanner'
import HowTo from '../Components/HowTo'
import Tecnologia from '../Components/Tecnologia'
import Footer from '../Components/Footer'
import { track } from "../analytics/meta";

export default function Home() {
  return (
    <>
      <span className='roll-top'>
        <a href="/#top">
          <img src="/iconos/flecha.png" alt="Icono de flecha" />
        </a>
      </span>
      <Header />
      <HeroBanner />
      <Phrase />
      <AboutUs />
      <SecondaryBanner
        title={"Únete. Comparte. Conecta."}
        subtitle={"Descarga la app y conectá con personas que comparten tu cultura, tus raíces y tu forma de amar. "}
        color={"linear-gradient(105deg, #9E81BA 0%, #ED484A 55%, #9E81BA 100%)"}
        sectionId="descargar"
      >
        <div className='d-flex justify-content-center mb-5 flex-lg-row flex-column'>
          <a 
            className='me-lg-3 mb-lg-0 mb-4 text-center'
            href="https://play.google.com/store/apps/details?id=com.kuska.kuskapp"
            onClick={() => track("DownloadPlayStore", { source: "home_secondbanner" })}  
          >Descargar - Play Store
          </a>
        </div>
        <div className='fichas-aux d-lg-flex d-none justify-content-center flex-column flex-lg-row'>
          <p  className='mb-4 mb-lg-0 me-lg-3'>Play Store - 20/02/26</p>
          <p className='mb-0 mb-lg-0 me-0'>App Store - Próximamente</p>
        </div>
      </SecondaryBanner>
      <Valores />
      <Caracteristicas />
      <HowTo />
      {/* <Testimonials /> */}
      <Tecnologia />
      <SecondaryBanner 
        title={"Conecta con tu comunidad, vive el amor a tu manera."}
        subtitle={"Kuska une raíces, tradiciones y sueños."}
        color={"linear-gradient(105deg, #9E81BA 0%, #ED484A 55%, #F49F67 100%)"}
      >
        <span className='lines-container'>
          <div className='line me-2'></div>
          <div className='line me-2'></div>
          <div className='line'></div>
        </span>
      </SecondaryBanner>
      <Footer />
    </>
  )
}
